import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import useQueryString from '../../../hooks/use-query-string'
import Typography from '../../Typography'
import Button from '../../Button'
import classes from './ScheduleAtShoob.module.sass'
import { routes } from '../../../routes'
import { Package, School } from '../../../models'
import { CustomerContext } from '../../../contexts/CustomerContext'
import { useShoobApptPricelist } from '../schedule-appointment/OtherSchoolTypeForm';

const ScheduleAtShoob = () => {
  const {
    status,
    t,
    s,
    p,
  } = useQueryString()
  const { customer, setCustomer } = useContext(CustomerContext)
  const [packageId, setPackageId] = useState()
  const [school, setSchool] = useState()
  const history = useHistory()
  const pricelist = useShoobApptPricelist();

  useEffect(() => {
    const schoolType = t === 0 ? 'elementary' : 'high school'

    if (p) {
      Package
        .find(p)
        .then((res) => {
          if (!res) return

          setPackageId(res.data.id)
        })
    } else {
      if (schoolType.toLowerCase().includes('elementary')) {
        Package
          .where({ schoolId: s, elementarySittings: true })
          .all()
          .then((res) => {
            if (res.data.length < 1) return

            setPackageId(res.data[0].id)
          })
      } else {
        Package
          .where({ schoolId: s, highSchoolSittings: true })
          .order({ shouldShowAppointments: false })
          .all()
          .then((res) => {
            if (res.data.length < 1) return

            setPackageId(res.data[0].id)
          })
      }
    }
  }, [])

  useEffect(() => {
    School
      .find(1075)
      .then((res) => setSchool(res.data))
  }, [])

  const handleClick = (route) => history.push(route)

  const goForward = async () => {
    customer.apptCart.schoolId = 1075
    customer.apptCart.package = pricelist;
    customer.apptCart.packageId = pricelist.id;
    await customer.apptCart.save()
    setCustomer({ ...customer, currentSchool: school })
    localStorage.setItem('schedule-at-shoob', 'true')
    handleClick(routes.appointmentOptionSelection(pricelist.id))
  }
  const goHome = () => handleClick(routes.home())

  return (
    <div className={classes.container}>
      {status === 0 && (
        <>
          <Typography align="center">
            There are no appointments at your school at this time.
          </Typography>
          <Typography align="center">
            Do you want to make an appointment at the Shoob Photography studio?
          </Typography>
          <div className={classes.btnContainer}>
            <Button rounded variant="primary" onClick={goForward}>Yes</Button>
            <Button rounded variant="error" onClick={goHome}>No</Button>
          </div>
        </>
      )}
      {status === 1 && (
        <>
          <Typography align="center">
            There are no appointments available at this time. Please check back again later.
          </Typography>
          <div className={classes.btnContainer}>
            <Button rounded variant="primary" onClick={goHome}>Return to Home</Button>
          </div>
        </>
      )}
    </div>
  )
}

export default ScheduleAtShoob
